/** Angular CustomHttpInterceptor Access Denied → navigate to dashboard (SPA). */
export const ACCESS_DENIED_REDIRECT_EVENT = 'lr:access-denied-redirect'
